import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectBillTotals } from "../../reduxStore/selectors/cartSelectors";
import { setDiscount } from "../../reduxStore/slices/cartSlice";
import { useNotify } from "../../utils/snackbarUtils";
import AppButton from "../app-button/AppButton";
import AppDialog from "../app-dialog/AppDialog";

function DiscountDialog({ isDiscountDialogOpen, onDialogCancel }) {
  const dispatch = useDispatch();
  const { showSuccess, showError } = useNotify();

  const [isLoading, setIsLoading] = useState(false);
  const [manualType, setManualType] = useState("PERCENTAGE");
  const [manualValue, setManualValue] = useState("");
  const [reason, setReason] = useState("");

  const bill = useSelector(selectBillTotals);
  const total = bill.itemAmount; // from redux

  const calculatedDiscount =
    manualType === "PERCENTAGE"
      ? Math.round((total * Number(manualValue)) / 100)
      : Number(manualValue);

  const handleApplyDiscount = () => {
    if (manualValue === "" || Number(manualValue) <= 0) {
      showError("Please enter a valid discount value.");
      return;
    }
    if (calculatedDiscount > total) {
      showError("Discount cannot exceed total amount.");
      return;
    }
    if (calculatedDiscount === total && reason.trim() === "") {
      showError("Please provide a reason for making the order free.");
      return;
    }
    setIsLoading(true);

    dispatch(
      setDiscount({
        type: manualType,
        value: Number(manualValue),
        reason: reason.trim(),
      })
    );
    setIsLoading(false);
    showSuccess("Discount applied successfully.");
    onDialogCancel();
  };

  const dialogDiscountFooter = (
    <>
      <Box
        style={{
          display: "flex",
          gap: 15,
        }}
      >
        <Button size="medium" onClick={onDialogCancel}>
          Cancel
        </Button>
        <AppButton
          disabled={isLoading}
          isLoading={isLoading}
          fullWidth
          size="medium"
          variant="contained"
          onClick={handleApplyDiscount}
        >
          Apply Discount
        </AppButton>
      </Box>
    </>
  );

  return (
    <>
      <AppDialog
        maxWidth="xs"
        isOpen={isDiscountDialogOpen}
        id={"discount_dialog"}
        title={<>{"Apply Discounts or Offers"}</>}
        footer={dialogDiscountFooter}
      >
        <Box
          style={{
            margin: "20px 5px",
          }}
        >
          <Stack spacing={3}>
            {/* Promo Code */}
            {/* <Box>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Promo Code
              </Typography>
              <Stack direction="row" spacing={1}>
                <TextField
                  fullWidth
                  size="small"
                  placeholder="Enter promo code"
                  // value={promoCode}
                  // onChange={(e) => setPromoCode(e.target.value)}
                />
                <Button variant="contained" color="primary">
                  Apply
                </Button>
              </Stack>
            </Box> */}

            {/* Loyalty Points */}
            {/* <Box>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Loyalty Points Available: <strong>340</strong>
              </Typography>
              <Stack direction="row" spacing={1}>
                <TextField
                  fullWidth
                  size="small"
                  type="number"
                  placeholder="Points to use"
                  // value={pointsToUse}
                  // onChange={(e) => setPointsToUse(e.target.value)}
                />
                <Button variant="contained" color="success">
                  Redeem
                </Button>
              </Stack>
            </Box> */}

            {/* Manual Discount */}

            <Box>
              <Typography variant="body2" sx={{ mb: 2 }}>
                Manual Discount
              </Typography>
              <Stack direction="row" spacing={1}>
                <FormControl size="small" sx={{ minWidth: 80 }}>
                  <InputLabel>Type</InputLabel>
                  <Select
                    value={manualType}
                    onChange={(e) => setManualType(e.target.value)}
                    label="Type"
                  >
                    <MenuItem value="PERCENTAGE">%</MenuItem>
                    <MenuItem value="FLAT">Rs.</MenuItem>
                  </Select>
                </FormControl>
                <TextField
                  autoComplete="manual_value"
                  fullWidth
                  size="small"
                  type="number"
                  placeholder="Value"
                  label="Value"
                  value={manualValue}
                  onChange={(e) => setManualValue(e.target.value)}
                />
              </Stack>
              <Box>
                {manualValue && Number(manualValue) > 0 && (
                  <Typography
                    variant="caption"
                    sx={{ mt: 1 }}
                    color={
                      calculatedDiscount > total
                        ? "error.main"
                        : calculatedDiscount === total
                        ? "#d7a202"
                        : "text.secondary"
                    }
                  >
                    {calculatedDiscount > total
                      ? "Discount exceeds total amount!"
                      : calculatedDiscount === total
                      ? "This discount will make the bill FREE. A reason will be required."
                      : `This equals ₹${calculatedDiscount} discount.`}
                  </Typography>
                )}
              </Box>
              {calculatedDiscount === total && (
                <Box sx={{ mt: 2 }}>
                  <Typography sx={{ mb: 3, fontSize: 12 }}>
                    You are making this order free. Please provide a reason.
                    This will be stored for audit and reporting.
                  </Typography>

                  <TextField
                    fullWidth
                    multiline
                    minRows={3}
                    label="Reason for Free Order"
                    placeholder="Enter reason (e.g. Owner guest, staff meal, complimentary)..."
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                  />
                </Box>
              )}
            </Box>

            {/* Available Offers */}
            {/* <FormControl>
              <FormLabel>Available Offers</FormLabel>
              <RadioGroup
              // value={selectedOffer}
              // onChange={(e) => setSelectedOffer(e.target.value)}
              >
                <FormControlLabel
                  value="10off"
                  control={<Radio />}
                  label="10% Off on Orders > Rs. 200"
                />
                <FormControlLabel
                  value="welcome50"
                  control={<Radio />}
                  label={
                    <span>
                      Flat Rs. 50 Off with Coupon: <strong>WELCOME50</strong>
                    </span>
                  }
                />
              </RadioGroup>
            </FormControl> */}
          </Stack>
        </Box>
      </AppDialog>
    </>
  );
}

export default DiscountDialog;
